import DefaultWidgetTemplate from '../DefaultWidgetTemplate';

export default function InecoRiskManagerDefaultWidget({ module }) {
  return (
    <DefaultWidgetTemplate
      module={module}
      route="user_module_inecoRiskManager_risk_list"
    />
  );
}
